import { CSSProperties } from 'react';
import { Size } from '@vivli/shared/theme';
import { ReportSafetyConcernListComponent } from './report-safety-concern-list.component';
import { ReportSafetyConcernFormComponent } from './report-safety-concern-form.component';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { SafetyConcernsContextWrapper } from '@vivli/features/data-requests/infrastructure/wrappers';
import { useSafetyConcernForm } from '@vivli/features/data-requests/infrastructure/hook';
import { ISafetyConcernReport } from '@vivli/features/data-requests/infrastructure/interface';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { FormProvider } from 'react-hook-form';

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: Size.INSET_SIZE,
    height: '100%',
    width: '100%'
};

export const ReportSafetyConcernComponent = () => {
    const { dataRequest } = useDataRequestContext();

    const { user } = useActiveUserContext();

    const safetyDefaultValues: ISafetyConcernReport = {
        name: user.name,
        email: user.email,
        phoneNumber: '',
        safetyConcernDescription: ''
    };

    const formApi = useSafetyConcernForm(safetyDefaultValues);

    return (
        <FormProvider {...formApi}>
            <div style={containerStyle}>
                <SafetyConcernsContextWrapper dataRequestId={dataRequest.id}>
                    <ReportSafetyConcernFormComponent />
                    <ReportSafetyConcernListComponent />
                </SafetyConcernsContextWrapper>
            </div>
        </FormProvider>
    );
};
